import scrollMonitor from 'scrollmonitor'
require('slick-carousel')

$(function() {

    function scrollTo() {

        $('.js-scroll-down').on('click', function(e){
            e.preventDefault();
            $('html,body').animate({
                scrollTop: $('.js-scroll-to').offset().top - headerHeight
            }, 'slow');
        });
    }

    scrollTo();

    var headerHeight = $('.site-header').outerHeight();
    var scrollTopDifference;

    function getHeaderHeight() {
        if ($(window).width() > 1023.9) {
            scrollTopDifference = 131;
        } else {
            scrollTopDifference = headerHeight;
        }
    }
    getHeaderHeight();

    $(window).on('resize', function(){
        getHeaderHeight();
    });

    function scrollWithinPage() {
        var $action = $('.js-scroll-action');
        $action.on('click', function(e) {
            e.preventDefault();
            var $this = $(this);
            var _location = $this.attr('data-target');
            var $location = $(''+_location+'');
            $('html,body').animate({
                scrollTop: $location.offset().top - scrollTopDifference
            }, 'slow');
        });
    }

    scrollWithinPage();




    $('.not-active').fadeOut();

    function featuredProducts() {
        function featuredProductsSlider() {
            var $slider = $('.js-featured-loop-wrapper.is-active .js-featured-products')

            $slider.slick({
                arrows: true,
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                  {
                    breakpoint: 800,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            })
        }
        featuredProductsSlider();

        $('.js-featured-nav-action').on('click', function(e){
            e.preventDefault();
            //console.log('fired');
            var $this = $(this);
            var $listName = $this.data('featured');
            var activeList = $(this).closest('.js-featured-nav-wrapper').find('.js-featured-loop-wrapper.is-active');
            var newList = $(this).closest('.js-featured-nav-wrapper').find('.js-featured-loop-wrapper[data-featured-list="'+$listName+'"]');
            var wrapperHeight = $('.js-featured-loop-wrapper.is-active').height();
            var wrapperWidth = $('.js-featured-loop-wrapper.is-active').width();
            $('.js-featured-loop-wrapper:not(is-active)').css('height', wrapperHeight);
            $('.js-featured-loop-wrapper:not(is-active)').css('width', wrapperWidth);

            $('.js-featured-nav-action.is-active').removeClass('is-active');
            $(this).addClass('is-active');

            $('.js-featured-loop-wrapper').removeClass('is-active')
            newList.addClass('is-active')
            $('.js-featured-loop-wrapper:not(is-active)').css('height', 'auto');
            $('.js-featured-loop-wrapper:not(is-active)').css('width', 'auto');
            newList.find('.js-featured-products').slick({
                arrows: true,
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                  {
                    breakpoint: 800,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            })
            //console.log('finished');
        });
    }


    featuredProducts()




    function customDropFunc() {
        var $this,
            $wrapper,
            $dropdownContent

        $('.js-dropbtn').on('click', function(e){
            e.stopPropagation();

            $this = $(this),
            $wrapper = $this.closest('.form-wrapper--select'),
            $dropdownContent = $this.closest('.js-dropdown').find('.js-dropdown-content');

            $wrapper.toggleClass('is-active');
            $dropdownContent.toggleClass('show');

        });

        function closeMenu() {
            $('.form-wrapper--select').removeClass('is-active');
            $('.js-dropdown').find('.js-dropdown-content').removeClass('show');
        }

        $(document.body).click( function(e) {
            closeMenu();
        });
    }

    customDropFunc();



    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));


    // disable parallax
        if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            $('.js-parallax-section').remove();
            $('.js-can-parallax').remove();
            $('.parallax-mirror').remove();
            $('.js-default-section').show();
        }
        else if(isSafari){
            $('.js-parallax-section').remove();
            $('.js-can-parallax').remove();
            $('.parallax-mirror').remove();
            $('.js-default-section').show();
        }
        else {
            $('.js-parallax-section').show();
            $('.js-default-section').remove();
        }



    $('.js-fire-zoom').on('click', function(e) {
        e.preventDefault();
        $('.js-lity-slider').slick();
    });

    // sort of confusing way of firing multiple slick modals on one page
    if ($('.pagetype-servicespage').length) {

        $.each($('.js-services-block-wrapper .js-services-block'), function(ind) {

            $(this).find('.js-services-img-popup').attr('id', 'services-img-popup-' + parseInt(ind + 1));
            $(this).find('.js-fire-service-popup').attr('data-lity-target', '#services-img-popup-' + parseInt(ind + 1));
        });

        $('.js-fire-service-popup').on('click', function(e) {
            e.preventDefault();

            var $this = $(this);
            $this.closest('.js-services-block').find('.js-lity-slider').slick();
        });

         $('.lity-close').on('click', function(){
            //console.log('closed');
         });
    }

});

